


















































import gql from '@/gqlService.coffee'
import settings from "@/settings.coffee"



export default {
    "name": 'ConsultantList',
    "props": {
        msg: String
        searchQuery: String
    }
    "methods":
        select: (item)->
           #@selectedConsultant = item
           this.$router.push({"name": "manage", "params": {'uid': item.uid}})
           this.$store.commit("select_consultant", item.uid)
        get_stat: (key, item)->
            clt_stat = @stats.reduce((acc, current)->
                ret = acc
                if current.consultant_id == item.uid
                    ret = current[key]
                return ret
            ,null)
            return clt_stat
    "data": ()->
        return {
            style: {}
            consultant_set: new gql.DataHolder({
                "model": "consultant_set"
                "fields": "uid fullname avatar unread_notifications_count"
            })
            backendMediaUrl: settings.backendMediaUrl,
            stats: @$store.state.stats
        }
    "computed":
        filteredConsultants: ->
            # Vérifier si les données sont chargées
            if not @consultant_set?.results?
                return [] # Retourner un tableau vide si les résultats ne sont pas disponibles
            
            # Vérifier que searchQuery est une chaîne de caractères et n'est pas vide
            if @searchQuery == ""
                return @consultant_set.results

            self = @
            # Filtrer les consultants en s'assurant que fullname est défini
            results = @consultant_set.results.filter (consultant) ->
                consultant?.fullname?.toLowerCase().includes(self.searchQuery.toLowerCase())

            return results
    "mounted": ()->
        if @$route.params.uid?
            this.$store.commit("select_consultant", @$route.params.uid)
        return
    "beforeDestroy":()->
        this.$store.commit("select_consultant", null)
                        
}
